import { minimatch } from "minimatch";
import { READ_ONLY_FILE_GLOBS } from "@imagine/ai-service/constants";

export function isReadOnlyPath(path: string): boolean {
  const normalized = path.startsWith("./") ? path.slice(2) : path;
  const posixPath = normalized.replaceAll("\\", "/");

  return READ_ONLY_FILE_GLOBS.some((pattern) => {
    const normalizedPattern = pattern.startsWith("./")
      ? pattern.slice(2)
      : pattern;

    const patternPosix = normalizedPattern.replaceAll("\\", "/");

    return minimatch(posixPath, patternPosix, { dot: true });
  });
}

export function markReadOnly<T extends { path: string }>(
  files: Array<T>,
): Array<T & { readOnly: boolean }> {
  return files.map((file) => ({
    ...file,
    readOnly: isReadOnlyPath(file.path),
  }));
}
